import React from "react";
import { publicAppUrl } from "../lib/api";
import WhatsAppShareButton, { SIGN_OFF } from "./WhatsAppShareButton";

/** Step-by-step WhatsApp message telling players how to join the club with its join code. */
export function joinStepsText(club) {
  const app = publicAppUrl();
  const code = club.join_code;
  return [
    `🏏 Join *${club.name}* on Cricso!`,
    "",
    `Club code: *${code}*`,
    "",
    "*New to Cricso?*",
    `1. Sign up at ${app}/register (email or Google)`,
    "2. On the *Set up your club* screen, tap *Join*",
    `3. Enter the code *${code}* and tap *Join club*`,
    "",
    "*Already on Cricso?*",
    `1. Open ${app} and go to *Profile* → *Club Invitations*`,
    `2. Under *Join with club code*, enter *${code}* and tap *Join*`,
    ...SIGN_OFF,
  ].join("\n");
}

export default function ShareJoinStepsButton({ club, className }) {
  if (!club?.join_code) return null;
  return (
    <WhatsAppShareButton
      getText={() => joinStepsText(club)}
      label="Share joining steps on WhatsApp"
      className={className}
      data-testid="share-join-steps-btn"
    />
  );
}
